//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import userChecks from '~/mixins/userChecks';
export default {
    mixins: [userChecks],
    name: 'videosFreeCollection',
    async fetch() {
        await Promise.all([ 
            this.$store.dispatch('pagesStore/getPage', 'freesexfilms'),
            this.$store.dispatch('bannerStore/getBanner', 'collection'),
            this.$store.dispatch('resourcesStore/getResources', this.queries.freeVideos)
        ])
    },
    head() {
        return {
            title: this.pages.freesexfilms ? this.pages.freesexfilms.seo.title : 'Sexfilms | Geile meiden in sex films | Meiden van Holland',
            meta: [
                { hid: 'title', name: 'title', content: this.pages.freesexfilms ? this.pages.freesexfilms.seo.title : 'Sexfilms | Sexfilms & Webcamsex met geile meiden | Meiden van Holland' },
                { hid: 'og:title', name: 'og:title', content: this.pages.freesexfilms ? this.pages.freesexfilms.seo.title : 'Sexfilms | Geile meiden in sex films | Meiden van Holland' },
                { hid: 'description', name: 'description', content: this.pages.freesexfilms ? this.pages.freesexfilms.seo.description : 'Bekijk geile sexfilms met Kim Holland en haar Hollandse meiden. Elke dag nieuwe sex en wekelijks een kersverse gratis sexfilm.'},
                { hid: 'og:description', name: 'og:description', content: this.pages.freesexfilms ? this.pages.freesexfilms.seo.description : 'Bekijk geile sexfilms met Kim Holland en haar Hollandse meiden. Elke dag nieuwe sex en wekelijks een kersverse gratis sexfilm.' },
                { hid: 'og:url', name: 'og:url', content: process.env.FE_URL + '/sexfilms/gratis' },
                { hid: 'keywords', name: 'keywords', content: this.pages.freesexfilms ? this.pages.freesexfilms.seo.keywords : 'sexfilms, Meiden van Holland sexfilms, sexfilm, sex films, gratis sexfilms, neukfilm'},
            ]
        }
    },
    components: {
        filters: () => import('~/components/filters/filtermodule.vue'),
        videoItem: () => import('~/components/content/video/video.vue'),
        dummyCollection: () => import('~/components/content/dummy/collection.vue'),
        banner: () => import('~/components/banner.vue'),
        about: () => import('~/components/about_section.vue'),
    },
    computed: {
        ...mapState({
            queries: ({ resourcesStore: {queries} }) => queries,
            pages: ({ pagesStore: {pages} }) => pages,
            freeVideos: ({ resourcesStore: {freeVideos} }) => freeVideos,
            loading: ({ resourcesStore: { loading } }) => loading
        }),
    },
}
